import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoggedInUserId } from '@selector/auth.selector';
import { logEvent } from '@action/global-app.actions'
import { selectUrl } from '@selector/route.selector';

export interface DrillModeEvent {
  eventType: 'drill_mode_on' | 'drill_mode_off';
  userId: number;
  timestamp: string;
  context: string;
  schoolName: string | null;
}

@Injectable({ providedIn: 'root' })
export class DrillModeEventService {
  constructor(private store: Store) {}

  sendDrillModeEvent(eventType: 'drill_mode_on' | 'drill_mode_off', schoolName: string | null) {
    this.store.select(selectLoggedInUserId).subscribe(userId => {
      this.store.select(selectUrl).subscribe(currentUrl => {
        const event: DrillModeEvent = {
          eventType,
          userId: userId ?? 0,
          timestamp: new Date().toISOString(),
          context: currentUrl,
          schoolName: schoolName
        };
        this.store.dispatch(logEvent({ payload: event }));
      }).unsubscribe();
    }).unsubscribe();
  }
}
